import { render, staticRenderFns } from "./EditingDFMateriality.vue?vue&type=template&id=655d01d4&"
import script from "./EditingDFMateriality.vue?vue&type=script&lang=js&"
export * from "./EditingDFMateriality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports